import { Component, Input, ViewChild } from "@angular/core";

import { NzOptionContainerComponent } from "ng-zorro-antd/select";
import { UiSelectItemInterface, UiSelectModeType } from "@webapp/ui/select/select.models";
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";

@Component({
  selector: "ui-option-container",
  exportAs: "uiOptionContainer",
  templateUrl: "option-container.component.html",
})
export class UiOptionContainerComponent extends NzOptionContainerComponent {
  @Input() public mode: UiSelectModeType = "default";
  @Input() public listOfContainerItem: UiSelectItemInterface[] = [];
  @ViewChild(CdkVirtualScrollViewport, { static: true }) public cdkVirtualScrollViewport!: CdkVirtualScrollViewport;
}
